import { ListItem } from '@uplift/types';
import { restClient } from '../client';

export type GetFaithsResponse = {
  data: ListItem[];
};

export const getFaiths = async () => {
  return await restClient.request<GetFaithsResponse>('/api/v1/faiths');
};
